import { render } from "./PanelTipsterProductos.vue?vue&type=template&id=9547ee32&scoped=true"
import script from "./PanelTipsterProductos.vue?vue&type=script&lang=js"
export * from "./PanelTipsterProductos.vue?vue&type=script&lang=js"

import "./PanelTipsterProductos.vue?vue&type=style&index=0&id=9547ee32&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9547ee32"]])

export default __exports__